<template>
  <div class="issue-messages">
    <h2 class="issue-messages__title">Messages</h2>

    <template v-if="messages.length">
      <div class="issue-messages__feed">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="issue-messages__message"
          :class="{ 'issue-messages__message--hr': message.sender_type === 'hr' }"
        >
          <div
            class="issue-messages__message-meta"
            :class="{ 'issue-messages__message-meta--hr': message.sender_type === 'hr' }"
          >
            <div class="issue-messages__message-author">
              {{ message.sender_name }}
            </div>
            <div class="issue-messages__message-date">
              {{ message.post_date | issueDate }}
            </div>
          </div>
          <div
            class="issue-messages__message-text"
            :class="{ 'issue-messages__message-text--hr': message.sender_type === 'hr' }"
          >
            {{ message.content }}
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <p class="issue-messages__empty">There are no messages in this conversation</p>
    </template>

    <div v-if="reply" class="isssue-messages__reply">
      <v-textarea
        v-model="message"
        flat
        solo
        outlined
        color="blue-light"
        height="96px"
        hide-details
        background-color="#FCFCFC"
        placeholder="Type your message here…"
        class="issue-messages__textarea"
      />
      <v-btn
        class="white--text mt-2"
        :disabled="message.length < 1"
        :processing="processing"
        color="blue"
        @click="submitMessage"
      >
        SEND
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: Array,
      required: true,
    },
    reply: {
      type: Boolean,
      required: true,
    },
    processing: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      message: '',
    };
  },

  methods: {
    submitMessage() {
      this.$emit('submit', this.message);
    },
  },
};
</script>

<style lang="scss">
.issue-messages {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 6px #00000029;

  &__title {
    font-size: 16px;
    line-height: 19px;
    font-weight: bold;
    margin-bottom: 32px;
  }

  &__message {
    margin-bottom: 32px;
    margin-right: 20%;

    &--hr {
      margin-right: 0;
      margin-left: 20%;
    }
  }
  &__message-meta {
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    &--hr {
      flex-direction: row-reverse;
    }
  }
  &__message-author {
    font-weight: 500;
  }
  &__message-text {
    font-size: 14px;
    line-height: 16px;
    padding: 16px;
    background: #FCFCFC;
    border-radius: 8px;

    &--hr {
      background: $color--blue-light;
    }
  }

  &__reply {
    border-top: 1px solid #E2E6EA;
    margin-top: 24px;
    margin-bottom: 24px;
  }
  &__textarea .v-input__slot fieldset {
    border: 1px solid #E2E6EA !important;
  }
  &__textarea textarea {
    font-size: 14px !important;
  }

  &__empty {
    color: $color--gray;
  }
}
</style>
